import { usePostHog } from '@posthog/react';
import { type FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const PostHogPageView: FC = () => {
  const posthog = usePostHog();
  const location = useLocation();

  useEffect(() => {
    if (!posthog) {
      return;
    }

    posthog.capture('$pageview', {
      $current_url: window.location.href,
    });
  }, [location.pathname, location.search, location.hash, posthog]);

  return null;
};
